<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Imágenes de Galería</h1>
      </div>
    </div>
    <div class="content__row">
      <image-list :filters="filters"></image-list>
      <image-view :image="image" v-if="imageAction === 'view' && image"></image-view>
      <image-edit @new="newImage" :image="image" v-if="imageAction === 'edit'" :key="key"></image-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'galleryGroupsView'}">Grupos de Galerías</router-link>
          <router-link class="btn btn__action btn--small" :to="{name: 'galleryView'}">Galerías</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
          <div class="form__container">
          <label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
              <option hidden :value="null">Selecciona un estatus</option>
              <option v-for="(status, index) in images_status" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newImage" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import imageList from './list'
import imageView from './view'
import imageEdit from './edit'
import {images_status} from './mocks'
export default {
  mixins: [
    httpService
  ],
  components: {
    imageList,
    imageView,
    imageEdit
  },
  data: function () {
    return {
      images_status: images_status,
      key: 0,
      galleryId: null,
      search: null,
      filters: undefined,
      imageAction: null,
      image: null,
      status_id: null
    }
  },
  created: function () {
    this.galleryId = this.$route.params.id
  },
  watch: {
    '$route.path': function () {
      this.galleryId = this.$route.params.id
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getImage(id, 'view')
    })
    this.$on('edit',id => {
      this.getImage(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = filter + '&search=' + this.search
      }
      if (this.status_id) {
        filter = filter + '&status_id=eq:' + this.status_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getImage: function (id, action) {
      this.imageAction = null
      let httpRequest = {
        params: '?gallery_id=eq:' + this.galleryId,
        module: 'gallery_images'
      }
      this.getById(id, httpRequest)
        .then(
          image => {
            this.image = image.data
            this.imageAction = action
          }
        )
    },
    newImage: function () {
      this.image = undefined
      this.key = ++this.key
      this.imageAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/gallery_images/images.vue